import request from './request';

const Api = {
    signIn: ({ email, password, rememberMe = '1', loginWithEmail = '1' }) =>
        request(`/user/login?key_access=${app.key_access}`, 'post', {
            email,
            password,
            rememberMe,
            loginWithEmail,
        }),
    signUp: (userData) => request(`/user/reg?key_access=${app.key_access}`, 'post', userData),
    sendEmail: ({ email }) => request('/user/send-email', 'post', { email }),
    changePassword: ({ password, newPassword, newPasswordConfirm }) =>
        request('/user/change-password', 'post', {
            password,
            newPassword,
            newPasswordConfirm,
        }),
    resetPassword: ({ key, password, passwordConfirm }) =>
        request('/user/reset-password', 'post', {
            key,
            password,
            passwordConfirm,
        }),
    logout: () => request('/user/logout', 'post'),
    profile: () => request('/user/profile'),
    balance: () => request('/user/balance'),
    headerSlider: () => request('/main/live-head'),
};

window.API = Api;
window.request = request;

export default Api;



// WEBPACK FOOTER //
// ./api/index.js